import styled from 'styled-components';
import { breakpoints } from '../../constants';

export const MapElement = styled.div`
    position: relative;
    overflow: hidden;
    height: 100%;

    @media (${breakpoints.smallMin}) {
        border-radius: 5px;
    }

    .gm-style {
        font-family: inherit;
    }

    .gm-style-iw,
    .gm-style-iw-d {
        max-width: none !important;
        overflow: hidden !important;
    }

    .cluster span {
        font-family: inherit;
        font-size: 16px;
    }

    .gm-style-iw-chr {
        display: none !important; /* Hides the default close button */
    }
`;
